import { render, staticRenderFns } from "./OtherStatOrders.vue?vue&type=template&id=46e766a6&scoped=true&"
import script from "./OtherStatOrders.vue?vue&type=script&lang=js&"
export * from "./OtherStatOrders.vue?vue&type=script&lang=js&"
import style0 from "./OtherStatOrders.vue?vue&type=style&index=0&id=46e766a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e766a6",
  null
  
)

export default component.exports